import { createFileRoute } from '@tanstack/react-router'
import { PasswordRecoveryPage } from '@/features/auth/components/PasswordRecoveryPage'

export const Route = createFileRoute('/forgot-password')({
  component: () => <PasswordRecoveryPage mode="forgot" />,
})
